var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "KModal",
    {
      attrs: { title: _vm.$tr("welcomeModalHeader") },
      on: {
        submit: function ($event) {
          return _vm.$emit("submit")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "KButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("submit")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.coreString("continueAction")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    _vm._l(_vm.paragraphs, function (paragraph, idx) {
      return _c("p", { key: idx, staticClass: "paragraph" }, [
        _vm._v("\n    " + _vm._s(paragraph) + "\n  "),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }